import { useEffect, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media";
import CommonUtil from '../../../common/commonUtil';
import { getCourseInfo, getYoyakuKanoTimeInfo } from "../../../const";
import Const from "../../../const/Const";
import MessageConst from "../../../const/messageConst";
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Label } from "../../atoms/label";
import { ModalClose } from "../../atoms/modalClose";
import { ErrorMassage } from "../../molecules/errorMassage";
import { PullDownOptionForm } from "../../molecules/pullDownOptionForm";
import { RadioButtonForm } from "../../molecules/radioButtonForm";

const RestaurantUserPopupContainer = (props) => {
    const {
        login,
        state,
        setPopupMode,
        setPopupMessage,
        onClickOpenPopupWindow,
        onClickClosePopupWindow,
        onClickOpenCalendarWindow,
        onClickOpenCoursePopup,
        restaurantInfo,
        restaurantReserveInfo,
        importedReserveComf,
        setRestaurantReserveInfo,
        setPopupData
        // setPeopleNum
    } = props;
    const store = useStore();
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupTitle = state.popupTitle ? state.popupTitle : "　";
    const popupMode = state.popupMode;
    const [peopleNumList, setPeopleNumList] = useState([]);
    const [courseNumList, setCourseNumList] = useState([]);
    const [timeChecked, setTimeChecked] = useState(false);

    const totalPeopleNumMax = 8;

    let dataList = [];
    let popupData = state.popupData;
    let popupDataList = state.popupDataList;
    let footerClass = "";
    const popupRef = useRef(null);
    const [errorInfo, setErrorInfo] = useState({ errorFlg: false, errorMessageBox: [] });

    const [riyoNinzuState, setRiyoNinzuState] = useState({adult:0, child:0, preschooler:0, baby:0});
    const handleChangeSelect = (event, name) => {
      setRiyoNinzuState((prev) => ({ ...prev, [name]: Number(event.target.value) }));
    };


    if (popupMode == 'yoyakuTime') {
        footerClass = "selectCourse"
        let reserveTimeFlg = restaurantInfo.changeFlg;
        let reserveTime = {};
        if (reserveTimeFlg) {
            reserveTime = importedReserveComf.foodList?.[0]?.foodTimeList?.[0];
        }
        popupData?.yoyakuKanoTimeInfoList?.forEach(value => {
            value?.yoyakuKanoTimeList?.forEach(timeValue => {
                if (reserveTimeFlg && reserveTime.jikantaiKbn == value.jikantai && reserveTime.startTime == timeValue.startTime) {
                    dataList.push({jikantai: value.jikantai, value: timeValue.startTime, akiFlg: true});
                } else {
                    dataList.push({jikantai: value.jikantai, value: timeValue.startTime, akiFlg: timeValue.akiFlg});
                }
            })
        })
        dataList.sort((a, b) => Number(a.value) - Number(b.value));
    } else if (popupMode == 'course') {
        footerClass = "decision";
        dataList = popupData.courseList;
    } else if (popupMode == 'people') {
        footerClass = "selectYoyakuTime";
        dataList = popupData.courseList;
    } else if (popupMode == "message" || popupMode == "doiInfo" || popupMode == "serviceInfo") {
        footerClass = "message"
    }
    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useEffect(() => {
        popupRef.current.scrollTop = 0;
        if (popupMode == "course") {
            let numList = [];
            // for (let i = 1; i <= 予約人数; i++) {
            for (let i = 0; i <= restaurantReserveInfo.peopleNum; i++) {
                numList.push({ id: i, value: i });
            }
            setCourseNumList(numList);
        } else if (popupMode == "people") {
            let numList = [];
            // for (let i = 1; i <= 予約人数; i++) {
            for (let i = 0; i <= totalPeopleNumMax; i++) {
                numList.push({ id: i, value: i });
            }
            setPeopleNumList(numList);
            const states = {
                adult: restaurantReserveInfo.adultCnt ? restaurantReserveInfo.adultCnt : 0, 
                child: restaurantReserveInfo.childCnt ? restaurantReserveInfo.childCnt : 0, 
                preschooler: restaurantReserveInfo.preschoolerCnt ? restaurantReserveInfo.preschoolerCnt : 0, 
                baby: restaurantReserveInfo.babyCnt ? restaurantReserveInfo.babyCnt : 0
              };
              setRiyoNinzuState(states);
        } else if (popupMode == 'serviceInfo') {
            if (document.getElementById("popupText")) {
                let element = document.getElementById("popupText");
                element.innerHTML = CommonUtil.replaceSpecialChar(popupData.serviceInfo.serviceText ? popupData.serviceInfo.serviceText : "");
            }
        } else if (popupMode == 'message') {
            if (document.getElementById("popupText")) {
                let element = document.getElementById("popupText");
                element.innerHTML = CommonUtil.replaceSpecialChar(state.popupMessage ? state.popupMessage : "");
            }
        } 
    }, [popupMode, state.membershipPopup]);

    // 予約時間一覧取得後処理
    const afterGetYoyakuKanoTimeInfo = (res) => {
        let errorFlg = false;
        let errorMessageBox = [];
        let data = res.data;
        if (data.resultCode == 0) {
            setPopupData({
                yoyakuKanoTimeInfoList: data.yoyakuKanoTimeInfoList
            });
            onClickOpenPopupWindow("yoyakuTime");
        } else {
            errorFlg = true;
            errorMessageBox = [data.errorMessage]
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
    }
    
    // 空き情報チェック処理
    const afterVacancyCheck = (res, refCourseList) => {
        let errorFlg = false;
        let errorMessageBox = [];
        let data = res.data;
        if (data.resultCode == 0) {
            let result = false;
            const yoyakuKanoTimeInfoList = data.yoyakuKanoTimeInfoList;
            yoyakuKanoTimeInfoList?.forEach(value => {
                value?.yoyakuKanoTimeList?.forEach(timeValue => {
                    if (timeValue.startTime == restaurantReserveInfo.yoyakuTime) {
                        result = true;
                        return;
                    }
                })
            })
            if (result) {
                setRestaurantReserveInfo({ ...restaurantReserveInfo, courseList: refCourseList });
                onClickClosePopupWindow()
            } else {
                errorFlg = true;
                errorMessageBox = [MessageConst.RESTAURANT_VACANCY_ERROR]
                popupRef.current.scroll({ top: 0, behavior: 'smooth' });
            }
        } else {
            errorFlg = true;
            errorMessageBox = [data.errorMessage]
            popupRef.current.scroll({ top: 0, behavior: 'smooth' });
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
    }

    // 決定
    const onClickDecide = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        let riyoNinzuSum = 0;
        let refCourseList = [];
        let reqCourseList = [];
        dataList.forEach((value, index) => {
            let courseNum = Number(document.getElementById(value.courseCd).value);
            if (courseNum > 0) {
                riyoNinzuSum += courseNum;
                refCourseList.push({
                    courseCd: value.courseCd,
                    courseName:value.courseName,
                    tanka: value.tanka,
                    courseNum: courseNum
                });
                reqCourseList.push({
                    courseCd: value.courseCd
                });
            }
        });

        if (riyoNinzuSum <= restaurantReserveInfo.peopleNum && (restaurantReserveInfo.peopleNum - restaurantReserveInfo.babyCnt - restaurantReserveInfo.preschoolerCnt) <= riyoNinzuSum) {
            // コース空き状態チェック
            if (!restaurantInfo.changeFlg) {
                let req = {
                    honkanShisetsuCd: restaurantInfo.honkanShisetsuCd,
                    shisetsuCd: restaurantInfo.shisetsuCd,
                    cornerBunKbn: "1",  /* 固定値 1:レストラン */
                    rstEstheCd: restaurantInfo.restaurantCd,
                    riyoDate: restaurantReserveInfo.riyoDate,
                    riyoNinzu: riyoNinzuSum,
                    jikantai: restaurantReserveInfo.jikantai,
                    courseList: reqCourseList,
                    importedFlg: true,
                }
                common.doPostRef(getYoyakuKanoTimeInfo, req, refCourseList, afterVacancyCheck);
            } else {
                setRestaurantReserveInfo({ ...restaurantReserveInfo, courseList: refCourseList });
                onClickClosePopupWindow();
            }
        } else {
            // エラー処理
            errorFlg = true;
            errorMessageBox = [MessageConst.VALID_INPUT_ERROR]
            popupRef.current.scroll({ top: 0, behavior: 'smooth' });
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
    }

    // 時間選択へ
    const toSelectYoyakuTime = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        let adultCnt = riyoNinzuState.adult;
        let childCnt = riyoNinzuState.child;
        let preschoolerCnt = riyoNinzuState.preschooler;
        let babyCnt = riyoNinzuState.baby;
        let peopleNum = adultCnt + childCnt + preschoolerCnt + babyCnt;
        if (peopleNum === 0) {
            errorFlg = true;
            errorMessageBox.push(MessageConst.IMPORTED_PEOPLE_NUM_ERROR)
            popupRef.current.scroll({ top: 0, behavior: 'smooth' });
        } else if (peopleNum > Const.MAX_IMPORTED_CAPACITY) {
            errorFlg = true;
            errorMessageBox.push(MessageConst.IMPORTED_PEOPLE_NUM_ERROR)
            popupRef.current.scroll({ top: 0, behavior: 'smooth' });
        } else if (adultCnt === 0) {
            errorFlg = true;
            errorMessageBox.push(MessageConst.VALID_INPUT_ERROR)
            popupRef.current.scroll({ top: 0, behavior: 'smooth' });
        }
        if (!errorFlg) {
            const newRestaurantReserveInfo = {
                ...restaurantReserveInfo,
                peopleNum,
                adultCnt,
                childCnt,
                preschoolerCnt,
                babyCnt
            };
            setRestaurantReserveInfo(newRestaurantReserveInfo);
            let reqCourseList = [];
            if (newRestaurantReserveInfo.courseList?.length > 0) {
                reqCourseList = newRestaurantReserveInfo.courseList.map(value => {
                    return { courseCd: value.courseCd };
                })
            }
            let req = {
                honkanShisetsuCd: restaurantInfo.honkanShisetsuCd,
                shisetsuCd: restaurantInfo.shisetsuCd,
                cornerBunKbn: "1",  /* 固定値 1:レストラン */
                rstEstheCd: restaurantInfo.restaurantCd,
                riyoDate: restaurantReserveInfo.riyoDate,
                riyoNinzu: peopleNum,
                jikantai: restaurantReserveInfo.jikantai,
                courseList: reqCourseList,
                importedFlg: true,
            }
            common.doPost(getYoyakuKanoTimeInfo, req, afterGetYoyakuKanoTimeInfo);
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });

    }

    // 時間変更
    const changeYoyakuTime = () => {
        let reqCourseList = [];
        if (restaurantReserveInfo.courseList?.length > 0) {
            reqCourseList = restaurantReserveInfo.courseList.map(value => {
                return { courseCd: value.courseCd };
            })
        }
        let req = {
            honkanShisetsuCd: restaurantInfo.honkanShisetsuCd,
            shisetsuCd: restaurantInfo.shisetsuCd,
            cornerBunKbn: "1",  /* 固定値 1:レストラン */
            rstEstheCd: restaurantInfo.restaurantCd,
            riyoDate: restaurantReserveInfo.riyoDate,
            riyoNinzu: restaurantReserveInfo.peopleNum,
            jikantai: restaurantReserveInfo.jikantai,
            courseList: reqCourseList,
            importedFlg: true,
        }
        common.doPost(getYoyakuKanoTimeInfo, req, afterGetYoyakuKanoTimeInfo);
    }

    // 食事コース一覧取得後処理
    const afterGetMealCourseList = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setPopupData({
                courseList: data.courseList
            });
        }
        onClickOpenPopupWindow("course");
    }

    // コース選択へ
    const toSelectCourse = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        // 選択した時間の受け渡し↓
        const selectTimes = document.getElementsByName("selectTime");


        let jikantaiTime = "";
        selectTimes.forEach(value => {
            if (value.checked) {
                jikantaiTime = value.value;
            }
        });
        if (jikantaiTime == "") {
            errorFlg = true;
            errorMessageBox.push(MessageConst.REQUIRE_INPUT_ERROR);
            popupRef.current.scroll({ top: 0, behavior: 'smooth' });
        }

        if (!errorFlg) {
            const info = jikantaiTime.split("_");
            const jikantai = info[0];
            const yoyakuTime = info[1];

            // 時間は確定
            let newRestaurantReserveInfo = restaurantReserveInfo;
            if (jikantaiTime !== restaurantReserveInfo.jikantai + "_" + restaurantReserveInfo.yoyakuTime) {
                // setRestaurantReserveInfo({ ...restaurantReserveInfo, jikantai, yoyakuTime, courseList: null });
                newRestaurantReserveInfo = { ...restaurantReserveInfo, jikantai, yoyakuTime };
                setRestaurantReserveInfo(newRestaurantReserveInfo);
            }
            // コース情報取得
            let req = {
                honkanShisetsuCd: restaurantInfo.honkanShisetsuCd,
                shisetsuCd: restaurantInfo.shisetsuCd,
                cornerBunKbn: "1", /* 固定値 */
                rstEstheCd: restaurantInfo.restaurantCd,
                jikantai: jikantai,
                riyoDate: restaurantReserveInfo.riyoDate,
            }
            common.doPost(getCourseInfo, req, afterGetMealCourseList);
            setPopupData({
                courseList: []
            });
        }
        setErrorInfo({ errorFlg: errorFlg, errorMessageBox: errorMessageBox });
    }

    // const handleCoursePeopleNumChange = (courseOptions, courseCd, targetCnt) => {

    //     // クローン
    //     const newCourse = courseOptions.map((item) => {
    //         return { ...item };
    //     });
    //     newCourse.filter(item => {
    //         return item.courseCd === courseCd;
    //     })[0].targetCnt = targetCnt;

    //     setCourse(newCourse);
    // }
    const onClickRadioForm = (id) => {
        let target = document.getElementById(id);
        target.click();
    }

    const getPopupText = () => {
        if (popupMode === 'doiInfo') {
            return popupData.doiInfo.text ? popupData.doiInfo.text : ""
        }
    }

    // 利用日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const playDate = new Date(restaurantReserveInfo.riyoDate);
        const m = playDate.getMonth() + 1;
        const d = playDate.getDate();
        return `${m}月${d}日(${youbi[playDate.getDay()]})`;
    }

    // 利用日選択カレンダー表示
    const onClickOpenCalendar = () => {
        let riyoDate = CommonUtil.getDateFromString(restaurantReserveInfo.riyoDate, "-");
        let startDate = new Date(riyoDate);
        startDate.setDate(1);
        startDate.setDate(startDate.getDate() - startDate.getDay());
        let baseDate = new Date();
        baseDate.setDate(baseDate.getDate() + 1)
        if ((baseDate.getFullYear() === riyoDate.getFullYear() && baseDate.getMonth() === riyoDate.getMonth()) || baseDate >= startDate) {
            startDate = new Date(baseDate);
        }
        const reqStartDate = CommonUtil.getStringFromDate(startDate,"yyyy-MM-dd");
        let reqReserveInfo = {...restaurantReserveInfo, riyoDate: reqStartDate};
        onClickOpenCalendarWindow(restaurantInfo, reqReserveInfo)
        onClickClosePopupWindow();
    }

    const popupBody = dataList ? dataList.map((value, index) => {
        if (popupMode == 'yoyakuTime') {
            return <>
                {value.akiFlg ?
                    <div key={"yoyakuTime" + index} className={errorInfo.errorFlg ? "errorMealTimeRadio2" : "mealTimeRadio2"} onClick={() => onClickRadioForm(value.value + "0")} >
                        <RadioButtonForm
                            id={value.value}
                            data={[{ value: value.jikantai + "_" + value.value, text: CommonUtil.getTimeStr(value.value, "hh:mm"), id: value.value, checked: value.value == restaurantReserveInfo.yoyakuTime }]}
                            name="selectTime"
                            inputClassName="inputRadioButtonGold"
                            labelClassName="timeRadioButton"
                        />
                    </div>
                    :
                    <div key={"yoyakuTime" + index} className={"mealTimeLabel2"}>
                        <Label
                            className="mealTimeCross"
                        />
                        <Label
                            label={CommonUtil.getTimeStr(value.value, "hh:mm")}
                            className="mansekiTimeLabel"
                        />
                    </div>
                }
            </>
        } else if (popupMode == 'course') {
            return <>
                {isMobilePhone ?
                    <div key={"course" + index} className={"courseRow"}  >
                        <div className="pullDownCourseNameWrapper">
                            {value.courseGazoURL ?
                                <a className={"blueLink"} onClick={() => onClickOpenCoursePopup(value)}>{value.courseName}</a>
                                :
                                <div>{value.courseName}</div>
                            }
                            <b><Label label={"料金￥" + value.tanka?.toLocaleString() + "（税・サ込）"} /></b>
                        </div>
                        {
                            courseNumList.length === 0 ? null : (
                                <PullDownOptionForm
                                    id={value.courseCd}
                                    divClass="coursePullDown2"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum2" : "pullDownCourseNum2"}
                                    data={courseNumList}
                                    defaultValue={restaurantReserveInfo.courseList && restaurantReserveInfo.courseList.find(course => course.courseCd === value.courseCd) ? restaurantReserveInfo.courseList.find(course => course.courseCd === value.courseCd).courseNum : 0}
                                />
                            )
                        }
                        <Label
                            label="人"
                        />
                    </div>
                    :
                    <div key={"course" + index} className={"courseRow"}  >
                        <div className="pullDownCourseNameWrapper">
                            {value.courseGazoURL ?
                                <a className={"blueLink"} onClick={() => onClickOpenCoursePopup(value)}>{value.courseName}</a>
                                :
                                <div>{value.courseName}</div>
                            }
                            <b><Label label={"料金￥" + value.tanka?.toLocaleString() + "（税・サ込）"} /></b>
                        </div>
                        {
                            courseNumList.length === 0 ? null : (
                                <PullDownOptionForm
                                    id={value.courseCd}
                                    divClass="coursePullDown2"
                                    selectClass={errorInfo.errorFlg ? "errorPullDownCourseNum2" : "pullDownCourseNum2"}
                                    data={courseNumList}
                                    defaultValue={restaurantReserveInfo.courseList && restaurantReserveInfo.courseList.find(course => course.courseCd === value.courseCd) ? restaurantReserveInfo.courseList.find(course => course.courseCd === value.courseCd).courseNum : 0}
                                />
                            )
                        }
                        <Label
                            label="人"
                        />
                    </div>
                }
            </>
        } else if (popupMode == 'people') {
            return <div key={"people" + index} className="peoplePullDownWrapper">
            <div className='inputHunmanNumWrapper'>
                <PullDownOptionForm
                    title={"大人"}
                    labelClassName="inputHunmanNumLabel"
                    id={"riyoAdultCnt"}
                    divClass="inputHunmanNum"
                    selectClass={errorInfo.errorFlg ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                    data={peopleNumList}
                    state={riyoNinzuState.adult}
                    onChange={(e) => handleChangeSelect(e, 'adult')}
                />
                <Label
                    label="人"
                />
            </div>
            <div className='inputHunmanNumWrapper'>
                <PullDownOptionForm
                    title={"小学生"}
                    labelClassName="inputHunmanNumLabel"
                    id={"riyoChildCnt"}
                    divClass="inputHunmanNum"
                    selectClass={errorInfo.errorFlg ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                    data={peopleNumList}
                    state={riyoNinzuState.child}
                    onChange={(e) => handleChangeSelect(e, 'child')}
                />
                <Label
                    label="人"
                />
            </div>
            <div className='inputHunmanNumWrapper'>
                <PullDownOptionForm
                    title={"幼児(3歳～5歳)"}
                    labelClassName="inputHunmanNumLabel"
                    id={"riyoPreschoolerCnt"}
                    divClass="inputHunmanNum"
                    selectClass={errorInfo.errorFlg ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                    data={peopleNumList}
                    state={riyoNinzuState.preschooler}
                    onChange={(e) => handleChangeSelect(e, 'preschooler')}
                />
                <Label
                    label="人"
                />
            </div>
            <div className='inputHunmanNumWrapper'>
                <PullDownOptionForm
                    title={"乳児(0歳～2歳)"}
                    labelClassName="inputHunmanNumLabel"
                    id={"riyoBabyCnt"}
                    divClass="inputHunmanNum"
                    selectClass={errorInfo.errorFlg ? "errorPullDownHumanNum" : "pullDownHumanNum"}
                    data={peopleNumList}
                    state={riyoNinzuState.baby}
                    onChange={(e) => handleChangeSelect(e, 'baby')}
                />
                <Label
                    label="人"
                />
            </div>
        </div>
        }

    }) : null;

    return (
        <div className={state.membershipPopup ? "popupIsShow" : "popup"} id="js-popup">
            <div ref={popupRef} className={isMobilePhone ? "inputUserPopupInner_media" : "inputUserPopupInner"}>
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickClosePopupWindow()} />
                <h4 className="popupInnerText" >{popupMode == "doiInfo" ? popupData.doiInfo.title : popupMode == "serviceInfo" ? popupData.serviceInfo.serviceTitle : popupTitle}</h4>
                <div className={errorInfo.errorFlg ? "errorDiv" : "hiddenItem"}>
                    <ErrorMassage data={errorInfo.errorMessageBox} />
                </div>
                <div className={popupMode == "yoyakuTime" ? "radioWrapper" : popupMode == "message" ? "popupMessageWrapper" : "popupBodyWrapper"}>
                {popupMode == "people" || popupMode == "yoyakuTime" || popupMode == "course"  ?
                        <div className="estheticPopupWrapper">
                            <Label
                                label="利用日"
                                className="estheticCourseLabel"
                            />
                            <div className="importedChangeArea">
                                <Label
                                    label={getDateToString()}
                                    className="estheticChangeLabel"
                                />
                                {restaurantInfo.changeFlg ? null :
                                    <Button
                                        buttonText="利用日変更"
                                        className="importedChangeBtn"
                                        onClick={() => onClickOpenCalendar(restaurantInfo, restaurantReserveInfo.riyoDate)}
                                    />
                                }
                            </div>
                        </div>
                        : null}
                    {popupMode == "yoyakuTime" || popupMode == "course" ?
                        <div className="restaurantNameWrapper">
                            <Label
                                label="利用人数" 
                                className="restaurantNameLabel"
                            />
                            <div className="importedChangeArea">
                                <Label
                                    label={restaurantReserveInfo.peopleNum + "人"}
                                    className="importedChangeLabel"
                                />
                                <Button
                                    buttonText="人数変更"
                                    className="importedChangeBtn"
                                    onClick={() => onClickOpenPopupWindow("people", restaurantInfo)}
                                />
                            </div>
                        </div>
                        : null}
                    {popupMode == "course" ?
                        <div className="restaurantNameWrapper">
                            <Label
                                label="時間"
                            // className="restaurantNameLabel"
                            />
                            <div className="importedChangeArea">
                                <Label
                                    label={CommonUtil.getTimeStr(restaurantReserveInfo.yoyakuTime, "hh:mm")}
                                    className="importedChangeLabel"
                                />
                                <Button
                                    buttonText="時間変更"
                                    className="importedChangeBtn"
                                    onClick={() => changeYoyakuTime()}
                                />
                            </div>
                        </div>
                        : null}
                    {popupMode == "message" || popupMode == "serviceInfo" ?
                        <div className="messageClass" >
                            <div id="popupText">
                            </div>
                        </div>
                        :
                        <>
                            {popupMode === "doiInfo" ?
                                <div className="messageClass" >
                                    <div id="popupText">
                                        {getPopupText()}
                                    </div>
                                    {popupData.doiInfo && popupData.doiInfo.link ?
                                        <a href={popupData.doiInfo.link} target="_blank" rel="noopener noreferrer"> {"「" + popupData.doiInfo.title + "」について"} </a>
                                        : null}
                                </div>
                                :
                                <>
                                    {popupBody}
                                </>
                            }
                        </>
                    }
                </div>
                <div className={footerClass == "decision" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="conditionSearch" onClick={onClickDecide} buttonClassName="buttonText" buttonText="決定" />
                </div>
                <div className={footerClass == "selectCourse" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className={"button"} onClick={toSelectCourse} buttonClassName="buttonText" buttonText="コース選択へ" />
                </div>
                <div className={footerClass == "selectYoyakuTime" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="button" onClick={toSelectYoyakuTime} buttonClassName="buttonText" buttonText="時間選択へ" />
                </div>
                <div className={footerClass == "message" ? "buttonArea2 buttonAreaSticky" : "hiddenItem"} >
                    <Button className="button" onClick={() => onClickClosePopupWindow()} buttonClassName="buttonText" buttonText="OK" />
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        restaurantInfo: state.restaurantInfo,
        restaurantReserveInfo: state.restaurantReserveInfo,
        importedReserveComf: state.importedReserveComf
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setRestaurantReserveInfo: (item) => {
            dispatch({ type: "RESTAURANT_RESERVE_INFO", payload: { restaurantReserveInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RestaurantUserPopupContainer);